
<!-- HEADER -->
<h2 class="text-center font-header-auth mb-4"> {{'step2.title' | translate | uppercase }} </h2>

<div class="col-10 m-auto">
    <hr class="text-muted mb-4">
</div>


<!-- SUBHEADER -->
<p class="col-10 mx-auto text-center font-primary">{{'step2.subheader' | translate }}</p>

<!-- FORM CONTROL -->
<form [formGroup]="miFormulario"
      (ngSubmit)="submitFormulario()"
      autocomplete="off">
    <!-- LINE 1 INPUT -->
    <div class="row justify-content-center">

        <!-- STEP 3 -->
        <div class="col-10">
            <p class="font-primary">{{'step2.step3' | translate }}</p>
        </div>

        <!-- FIRST NAME --> 
        <div class="col-10 col-md-4 mb-4 position-relative">
            <input 
                type="text"
                formControlName="firstName"
                [ngClass]="{'is-invalid': submitted && miFormulario.controls.firstName.errors } "
                maxlength="50" 
                class="font-primary input-gbl form-control form-control-step3" 
                placeholder="{{'inputs.firstName' | translate }}"
                autocomplete="off">
            <span class="invalid-tooltip"
                  *ngIf="validacionCampo('firstName')">
                {{ firstNameErrorsMsg | translate }}
            </span>
        </div>

        <!-- LAST NAME --> 
        <div class="col-10 col-md-6 mb-4 position-relative">
            <input 
                type="text"
                formControlName="lastName"
                [ngClass]="{'is-invalid': submitted && miFormulario.controls.lastName.errors} "
                maxlength="50" 
                class="font-primary input-gbl form-control form-control-step3" 
                placeholder="{{'inputs.lastName' | translate }}"
                autocomplete="off">
            <span
                class="invalid-tooltip"
                *ngIf="validacionCampo('lastName')">
                {{ lastNameErrorsMsg | translate }}
            </span>
        </div>

        <!-- EMAIL ADRESS -->
        <div class="col-10  mb-4 position-relative">
            <input 
                type="email"
                formControlName="email"
                [ngClass]="{'is-invalid':submitted && miFormulario.controls.email.errors} "
                maxlength="50" 
                class="font-primary input-gbl form-control m-auto form-control-step3" 
                placeholder="{{'inputs.emailAddress' | translate }}"
                autocomplete="off" (keyup)="addUserName()">
            <span
                class="invalid-tooltip"
                *ngIf="validacionCampo('email')">
                {{ emailErrorsMsg | translate }}
            </span>
        </div>

        <!-- Phone -->
        <div class="col-10  mb-4 position-relative">
            <input 
                type="number"
                formControlName="main_tlf"                
                maxlength="10" 
                class="font-primary input-gbl form-control m-auto form-control-step3" 
                placeholder="{{'inputs.phone' | translate }}"
                autocomplete="off">
            <span
                class="invalid-tooltip"
                *ngIf="validacionCampo('main_tlf')">
                {{ emailErrorsMsg | translate }}
            </span>
        </div>
    </div>
    

    <!--LINE 2 INPUT -->
    <div class="row justify-content-center">

        <!-- STEP 3 -->
        <div class="col-10">
            <p class="font-primary">{{'step2.step4' | translate }}</p>
        </div>

        <!-- USERNAME -->
        <div class="col-10  mb-4 position-relative">
            <input 
                type="text"
                [ngModel]="alias"
                formControlName="username"
                [ngClass]="{'is-invalid': submitted && miFormulario.controls.username.errors } "
                maxlength="50" 
                class="font-primary input-gbl form-control m-auto form-control-step3" 
                placeholder="{{'inputs.username' | translate }}"
                autocomplete="off">
            <span
                class="invalid-tooltip"
                *ngIf="validacionCampo('username')"> 
                {{ usernameErrorsMsg | translate }}
            </span>
        </div>

        <!-- PASSWORD -->
        <div class="col-10  mb-4 position-relative">
            <input  type="password"
                    formControlName="password"
                    [ngClass]="{'is-invalid': submitted && miFormulario.controls.password.errors} "
                    maxlength="50" 
                    class="font-primary input-gbl form-control m-auto form-control-step3" 
                    placeholder="{{'inputs.password' | translate }}"
                    autocomplete="off">
            <span 
                class="invalid-tooltip"
                *ngIf="validacionCampo('password')"> 
                {{ passwordErrormsg | translate }}
                <!-- Password must have more than 6 letters  -->
        </span>
        </div>

        <!-- PASSWORD CONFIRM -->
        <div class="col-10  mb-4 position-relative">
            <input  type="password"
                    formControlName="confirmPassword"
                    [ngClass]="{'is-invalid':submitted && miFormulario.controls.confirmPassword.errors} "
                    maxlength="30" 
                    class="font-primary input-gbl form-control m-auto form-control-step3" 
                    placeholder="{{'inputs.confirmPassword' | translate }}">
            <span 
                class="invalid-tooltip"
                *ngIf="validacionCampo('confirmPassword')"
                autocomplete="off">
                {{ 'message.password_confirm' | translate}}
            </span>

        </div>
    </div>
    
    <!-- BUTTON SUBMIT -->
    <div class="text-center mb-4">
        <button
            type="button"
            class="btn-secondary-gbl"
            routerLink="/auth/sign-up">
            {{'buttons.back' | translate | uppercase }}
        </button>
        <button
            type="submit"
            class="btn-primary-gbl">
            {{'buttons.signup' | translate | uppercase }}
        </button>
    </div>

</form>